import React, { useContext } from 'react';

import { GridRowParams, GridValueFormatterParams } from '@mui/x-data-grid';

import CustomDataGrid from '../../components/data-grid';
import { AppContext } from '../../contexts/app-context';
import GlobalStyles from '../../global-styles';
import { formatDateForDataGrid, goToRoutePage } from '../../utils/helper';
import { Box } from '../../utils/material-ui-core';

const KitList = () => {
  const globalStyles = GlobalStyles();

  const { writeLog, kits } = useContext(AppContext);

  const columns = [
    { field: "hsbKitNo", headerName: "Kit #", width: 150 },
    { field: "name", headerName: "Name", width: 300 },
    { field: "active", headerName: "Active", width: 150, type: "boolean" },
    {
      field: "subscriptionBilling",
      headerName: "Subscription Billing",
      width: 250,
      type: "boolean",
    },
    {
      field: "committmentPeriod",
      headerName: "Committment Period",
      width: 200,
      filterable: false,
      hide: true,
    },
    {
      field: "replacementKit",
      headerName: "Replacement Kit",
      width: 200,
      type: "boolean",
    },
    {
      field: "fulfillmentVendorName",
      headerName: "Fulfillment Vendor Name",
      width: 250,
      hide: true,
    },
    {
      field: "platformVendorName",
      headerName: "Platform Vendor Name",
      width: 250,
      hide: true,
    },
    {
      field: "kitItemCount",
      headerName: "#Item",
      width: 150,
      type: "number",
      filterable: false,
      hide: true,
    },
    {
      field: "programCount",
      headerName: "# Program",
      width: 150,
      type: "number",
      filterable: false,
      hide: true,
    },
    {
      field: "programCodes",
      headerName: "Program Codes",
      width: 150,
      filterable: false,
      hide: true,
    },
    {
      field: "enrollmentCount",
      headerName: "# Enrolled",
      width: 150,
      type: "number",
      hide: false,
    },
    {
      field: "lastModifiedBy",
      headerName: "Last Modified By",
      width: 250,
      hide: true,
    },
    {
      field: "lastModifiedDateTime",
      headerName: "Last Modified Date",
      width: 200,
      type: "dateTime",
      valueFormatter: (params: GridValueFormatterParams) => formatDateForDataGrid(params.value as string),
    },
    {
      field: "kitKey",
      headerName: "Key",
      width: 150,
      filterable: false,
      hide: true,
    },
  ];

  const handleDataGridClick = (params: GridRowParams, event: any) => {
    const path = "onboarding/kits/" + params.row.kitKey;
    writeLog("Onboarding Page", "Opening kit detail.", params.row.kitKey, "kit");
    goToRoutePage(path);
  };

  const getData = () => {
    const rows: any = [];
    kits.map((kit, index) => rows.push({ id: index, ...kit }));
    return rows;
  };

  return (
    <Box className={globalStyles.onboardingDatagridContainer}>
      <CustomDataGrid uniqueGridCode={"KitListResult"} columns={columns} rows={getData()} showToolBar={true} sortModel={[{ field: "name", sort: "asc" }]} handleDataGridClick={handleDataGridClick} />
    </Box>
  );
};

export default KitList;
